import { Routes } from '@angular/router';

import { UserRouteAccessCrudService } from '../../shared';
import { HomeLayoutComponent } from './../../Layout/template/home-layout.component';
import { ItemPreviewPopupComponent } from './item-preview-dialog.component';


export const invoiceHtmlPopupRoute: Routes = [
    {
        path: 'invoice-html/:id/:companyId',
		component: ItemPreviewPopupComponent,
    },
];
